// extracted by css-extract-rspack-plugin
export default {"widget":"JlLaA","container":"oUjLQ","inputContainer":"IzK_3","submitButton":"EuCOY","cancelButton":"K2JIr"};